export const formatNumber = (number) => {
	if (isNaN(number)) {
		return number;
	}

	return number.toLocaleString('pl-PL', {
		style: 'decimal',
	});
};

export const formatArea = (num) => {
	if (num) {
		const roundedNumber = num.toFixed(2);
		const localeString = (number) =>
			number.toLocaleString('pl-PL', {
				minimumFractionDigits: 2,
			});

		return localeString(+roundedNumber);
	}
	return '';
};

export const convertNumberToHHMM = (num) => {
	const milliseconds = num * 60 * 60 * 1000;
	const timeString = new Date(milliseconds).toISOString().slice(11, 16);
	let [hours, minutes] = timeString.split(':');
	hours = parseInt(hours, 10);

	return `${hours}:${minutes}`;
};

export const convertArrayToHoursRange = (arr, num, t) => {
	if (!arr || arr.length === 0) {
		if (num === null) return t('not_calculated');
		if (num === 0) return t('no_window');
		return t('lack_of_sun');
	}
	const ranges = arr.map((range) => {
		const [start, end] = range;
		return `${convertNumberToHHMM(start)} - ${convertNumberToHHMM(end)}`;
	});
	return ranges.join(', ');
};

export const convertArrayToHoursRange2 = (arr, t) => {
	if (!arr || arr.length === 0) {
		return t('lack_of');
	}
	const ranges = arr.map((range) => {
		const [start, end] = range;
		return `${convertNumberToHHMM(start)} - ${convertNumberToHHMM(end)}`;
	});
	return ranges.join(', ');
};

export const calculateWindowAreaRatio = (window, floor, t) => {
	if (!window || window === '0') {
		return t('lack_of');
	} else {
		const windowRatio = (window / floor / 0.125) * 100;
		return `${windowRatio.toFixed(0)}%`;
	}
};

export const sumSunLightRanges = (arr) => {
	if (!arr || arr.length === 0) return 0;
	let sum = 0;
	arr.forEach((range) => {
		sum += range[1] - range[0];
	});
	return sum;
};

export const formatExpositionName = (direction, t) => {
	switch (direction) {
		case 'N':
			return t('north_short');
		case 'E':
			return t('east_short');
		case 'S':
			return t('south_short');
		case 'W':
			return t('west_short');
		case 'NE':
			return t('northeast_short');
		case 'NW':
			return t('northwest_short');
		case 'SE':
			return t('southeast_short');
		case 'SW':
			return t('southwest_short');
		default:
			return direction;
	}
};

export const renderExposition = (expositionArray, t) => {
	if (!expositionArray || expositionArray.length === 0) {
		return t('lack_of');
	}
	const formattedDirections = expositionArray.map((dir) =>
		formatExpositionName(dir, t)
	);
	return formattedDirections.join(', ');
};
